var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[_vm._t("heading"),_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.$emit('submit', $event)}}},[_vm._t("form-heading"),_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }